// import { observable } from "mobx";
var StakeButtonsStatusesModel = /** @class */ (function () {
    function StakeButtonsStatusesModel(source) {
        this.plusEnabled = source.plusEnabled;
        this.minusEnabled = source.minusEnabled;
    }
    return StakeButtonsStatusesModel;
}());
export { StakeButtonsStatusesModel };
//# sourceMappingURL=StakeButtonsStatusesModel.js.map